import Layout from "@/components/Layout"

function Glossary() {
  const glossaryTerms = [
    {
      term: "Depreciation Tax Shield",
      definition:
        "The reduction in income taxes that results from taking an allowable deduction from taxable income. Depreciation expense reduces taxable income, creating a tax benefit.",
    },
    {
      term: "Book Value",
      definition:
        "The net value of an asset on a company's balance sheet, calculated as the original cost minus accumulated depreciation. Also known as carrying value.",
    },
    {
      term: "Section 179",
      definition:
        "An IRS tax code that allows businesses to deduct the full purchase price of qualifying equipment and software purchased or financed during the tax year.",
    },
    {
      term: "Salvage Value",
      definition:
        "The estimated residual value of an asset at the end of its useful life. This is the amount you expect to receive when you dispose of the asset.",
    },
    {
      term: "Useful Life",
      definition:
        "The estimated period over which an asset is expected to be used by a business. The IRS provides guidelines for useful life of various asset categories.",
    },
    {
      term: "Accumulated Depreciation",
      definition:
        "The total amount of depreciation expense that has been recorded for an asset since it was put into use. It is a contra-asset account.",
    },
    {
      term: "Straight Line Depreciation",
      definition:
        "A depreciation method that spreads the cost of an asset evenly over its useful life. Annual depreciation = (Cost - Salvage Value) / Useful Life.",
    },
    {
      term: "Double Declining Balance",
      definition:
        "An accelerated depreciation method that depreciates assets twice as fast as the straight line method in the early years of an asset's life.",
    },
    {
      term: "MACRS",
      definition:
        "Modified Accelerated Cost Recovery System - The current tax depreciation system in the United States, introduced in 1986.",
    },
    {
      term: "Form 4562",
      definition:
        "The IRS form used to claim deductions for depreciation and amortization, as well as Section 179 deductions.",
    },
  ]

  return (
    <Layout>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="mb-12">
          <h1 className="text-4xl font-bold text-gray-900 mb-4">
            Depreciation Glossary
          </h1>
          <p className="text-lg text-gray-600">
            Essential terms and definitions for understanding depreciation and
            amortization calculations.
          </p>
        </div>

        <div className="grid grid-cols-1 gap-6">
          {glossaryTerms.map((item) => (
            <div
              key={item.term}
              className="bg-white rounded-lg border border-gray-200 p-6"
            >
              <h2 className="text-xl font-semibold text-gray-900 mb-2">
                {item.term}
              </h2>
              <p className="text-gray-600">{item.definition}</p>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  )
}

export default Glossary
